
import { useState, useEffect } from 'react';

import './App.css';

import 'lenis/dist/lenis.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';

import Routers from './routers';
import PageLoader from '../src/component/PageLoader';

function App() {
  const [loading, setLoading] = useState(true);
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    let isMounted = true;
const checkImagesLoaded = async () => {
  // Wait for the browser's initial page load.
  if (document.readyState !== 'complete') {
    await new Promise((resolve) => {
      window.addEventListener('load', resolve, { once: true });
    });
  }

  // Wait for images currently present in the document (max 8s).
  const images = Array.from(document.images);

  const imagesReady = Promise.all(
    images.map((img) => {
      if (img.complete) {
        return Promise.resolve();
      }

      return new Promise((resolve) => {
        img.addEventListener('load', resolve, { once: true });
        img.addEventListener('error', resolve, { once: true });
      });
    })
  );

  const timeout = new Promise((resolve) => setTimeout(resolve, 8000));

  await Promise.race([imagesReady, timeout]);

  if (!isMounted) return;

  // PageLoader plays its exit animation, then calls onComplete,
  // which hides it via setShowLoader(false).
  setLoading(false);
};

checkImagesLoaded();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="App">
      <Routers />
{showLoader && (
  <PageLoader loading={loading} onComplete={() => setShowLoader(false)} />
)}
    </div>
  );
}

export default App;

